import * as $utils from '../../assets/js/utils'

/**
 * @method 这是路由钩子函数
 * @param { Object } to   到哪里去的路由对象
 * @param { Object } from 从哪里来的路由对象
 * @param { Function } next 路由钩子函数
 */
export default (to, from, next) => {
  if (to.query.appSrc) {
    $utils.sessionCache('appSrc', to.query.appSrc)
  }
  if (to.query.tokenStr) {
    setCookie('uid', to.query.miniUid)
    setCookie('token', to.query.tokenStr)
  }
  window.scrollTo(0, 0)
  setTimeout(() => {
    next()
  }, 100)
}

function setCookie (cname, cvalue) {
  document.cookie = `${cname}=${cvalue};Path=/;domain=${location.hostname}`
}



// WEBPACK FOOTER //
// ./src/router/route-hook/beforeEach.js